export enum AppMode {
  Standard = 2,
  Download = 3,
}

export enum NetworkError {
  CreateEmailDigest = 1,
  DeleteEmailDigest,
  DeleteReport,
  GetReports,
  GetEmailDigests,
  RestoreEmailDigest,
  RestoreReport,
  UpdateChartOptions,
  UpdateEmailDigest,
  UpdateName,
  AddBookmarks,
  GetBookmarks,
  GetProjectInfo,
  GetUserInfo,
}

// In pixels per second
export enum ScrollSpeed {
  Fast = 1200,
  Slow = 400,
}

export enum ScrollDirection {
  Up,
  Down,
}

export enum ChartLayoutMode {
  Compact = `compact`,
  Standard = `standard`,
}

export enum SegFilterPropertyTypes {
  Boolean = `boolean`,
  DateTime = `datetime`,
  List = `list`,
  Number = `number`,
  Object = `object`,
  String = `string`,
  Unknown = `unknown`,
}

export enum FormDialogMode {
  Create = `create`,
  Duplicate = `duplicate`,
  Edit = `edit`,
}
